import {gsap} from "../../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {AppearingContainer} from "./AppearingContainer";
import {TranslatableText} from "./TranslatableText";
import {Point} from "pixi.js";

// Constructor
export class TextIntro extends AppearingContainer {

  constructor(appearingScreenPercent, screenData, game) {
    super(appearingScreenPercent, game);

    this.game = game;
    this._zIndex = 999;

    this.stepsTimeline = false;

    // Text styles
    this.textTitleStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 220,
      fontWeight: 500,
      lineHeight: 220,
      fill: "#343B6F",
      align: "left",
      padding: 50,
    });

    this.textSubtitleStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 120,
      fontWeight: 500,
      lineHeight: 120,
      fill: "#343B6F",
      align: "left",
      padding: 15,
    });

    this.textParagraphStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 46,
      fontWeight: 400,
      lineHeight: 56,
      fill: "#343B6F",
      align: "left",
      wordWrap: true,
      wordWrapWidth: 1000,
    });

    this.build(screenData);
  }

  build(screenData) {

    // Container
    this.step1ENContainer = new PIXI.Container();
    this.step1ENContainer.position.set(1922, 750);
    this.step1ENContainer.alpha = 1.0;
    this.step1FRContainer = new PIXI.Container();
    this.step1FRContainer.position.set(1922, 750);
    this.step1FRContainer.alpha = 1.0;

    this.step2ENContainer = new PIXI.Container()
    this.step2ENContainer.position.set(1900, 780);
    this.step2ENContainer.alpha = 0.0;
    this.step2FRContainer = new PIXI.Container();
    this.step2FRContainer.position.set(1900, 780);
    this.step2FRContainer.alpha = 0.0;

    // Step 1
    const anchorENContainer = new PIXI.Container();
    const anchorFRContainer = new PIXI.Container();
    this.step1ENContainer.addChild(anchorENContainer);
    this.step1ENContainer.addChild(anchorFRContainer);
    this.addChild(this.step1ENContainer);
    this.addChild(this.step1FRContainer);

    const step1TextTitleEN = new TranslatableText(screenData.text["step-1"].title.en, this.textTitleStyle, "en", this.game).getText();
    const step1TextTitleFR = new TranslatableText(screenData.text["step-1"].title.fr, this.textTitleStyle, "fr", this.game).getText();

    const step1TextEN = new TranslatableText(screenData.text["step-1"].text.en, this.textParagraphStyle, "en", this.game).getText();
    const step1TextFR = new TranslatableText(screenData.text["step-1"].text.fr, this.textParagraphStyle, "fr", this.game).getText();
    step1TextEN.position.set(0, step1TextTitleEN.height - 38);
    step1TextFR.position.set(0, step1TextTitleFR.height - 38);

    anchorENContainer.addChild(step1TextTitleEN);
    anchorENContainer.addChild(step1TextEN);
    anchorFRContainer.addChild(step1TextTitleFR);
    anchorFRContainer.addChild(step1TextFR);

    // Offset position to the middle (anchor behavior)
    anchorENContainer.position.set(-anchorENContainer.width / 2, -anchorENContainer.height / 2);
    anchorFRContainer.position.set(-anchorFRContainer.width / 2, -anchorFRContainer.height / 2);

    // Step 2
    const step2TextTitleEN = new TranslatableText(screenData.text["step-2"].en, this.textSubtitleStyle, "en", this.game).getText();
    const step2TextTitleFR = new TranslatableText(screenData.text["step-2"].fr, this.textSubtitleStyle, "fr", this.game).getText();

    step2TextTitleEN.position.set(-step2TextTitleEN.width / 2, -step2TextTitleEN.height / 2);
    step2TextTitleFR.position.set(-step2TextTitleFR.width / 2, -step2TextTitleFR.height / 2);
    this.step2ENContainer.addChild(step2TextTitleEN);
    this.step2FRContainer.addChild(step2TextTitleFR);
    this.addChild(this.step2ENContainer);
    this.addChild(this.step2FRContainer);

    // build the steps animation
    this.stepsTimeline = gsap.timeline({
      paused: true,
    });

    this.stepsTimeline.fromTo([this.step1ENContainer, this.step1FRContainer], {alpha: 1}, {alpha: 0.0, duration: 0.40});
    this.stepsTimeline.fromTo([this.step2ENContainer, this.step2FRContainer], {alpha: 0}, {alpha: 1.0, duration: 0.40});

    this.reset();
  }

  buildAnimations() {
    // No animation for now
    // this.inAnimation = gsap.timeline({paused: true, immediateRender: true});
    // this.inAnimation.to(this, {alpha: 1.0, duration: 1.0, ease: "sine.inOut"});
  }

  nextStep() {
    this.stepsTimeline.play();
  }

  resetSteps() {
    // Return to default state
    this.stepsTimeline.pause().progress(0);
  }

  getPositionOnScreen() {
    if (this.step1ENContainer.width > this.step1FRContainer.width) {
      return this.step1ENContainer.toGlobal(new Point(0, 0));
    } else {
      return this.step1FRContainer.toGlobal(new Point(0, 0));
    }
  }

}
